import withRouter from "hoc/withRouter";
import { Button, CircularProgress, Pagination, TextField } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import { useEffect, useState } from "react";
import { toDate, toFullDateName } from "helpers/dateHelper";
import { toCurrencyFormat } from "helpers/utils";
import AppTable from "components/AppTable/AppTable";
import { Link } from "react-router-dom";
import { urlReplaceState } from "helpers/url";
import { useForm } from "react-hook-form";
import { LIMIT } from "data/consts";
import { useGetSubOrders } from "hooks/useGetSubOrders";
import { OrderStatus } from "components/OrderStatus";
import { i18n } from "data/i18n";
import { SUB_ORDER_TYPE } from "enums/enums";

const columnConfig = [
    {
        key: 'id',
        label: '#',
        render: (b) => {
            return <Link className="color-blue" to={`/admin/products/sub-orders/view/${b.id}`}>
                {b.id}
            </Link>
        }
    },
    {
        key: 'createdAt',
        label: 'Дата создания',
        formatter: (v) => toDate(v)
    },
    {
        key: 'customer',
        label: 'Покупатель',
        render: (i) => `${i.customer?.lastName} ${i.customer?.firstName}`
    },
    {
        key: "orderItems",
        label: 'Товары',
        render: (i) => i.orderItems?.map(item => `${item?.name} - (${item?.quantity} шт.)`).join(', ')
    },
    {
        key: 'totalAmount',
        label: 'Общая стоимость',
        render: (i) => toCurrencyFormat(i.totalAmount, i.currency)
    },
    {
        key: 'status',
        label: 'Статус',
        render: (i) => <OrderStatus status={i.status}></OrderStatus>
    },
    {
        key: 'deliveryMethod',
        label: 'Способ доставки',
        render: (i) => i.deliveryMethod ? i18n[i.deliveryMethod] : ""
    },
    {
        key: 'deliveryAddress',
        label: 'Адрес доставки',
        render: (i) => `${i.deliveryAddress?.city?.name}, ${i.deliveryAddress?.address}, ${i.deliveryAddress?.appartmentNumber}`
    },
    {
        key: 'deliveryDateTo',
        label: 'Дата доставки',
        render: (i) => toFullDateName(i.deliveryDateTo)
    },
    {
        key: "deliveryFee",
        label: 'Стоимость доставки',
        render: (i) => toCurrencyFormat(i.deliveryFee, i.currency)
    },
    // {
    //     key: 'view',
    //     label: '',
    //     render: (b) => {
    //         return <div className="flex gap-8">
    //             <Link to={`/admin/bookings/view/${b.id}`}>
    //                 <IconButton size="small">
    //                     <MdArticle></MdArticle>
    //                 </IconButton>
    //             </Link>
    //         </div>
    //     }
    // },
]

const SubOrders = ({ router: { queryParams } }) => {
    const [query, setQuery] = useState({
        page: queryParams.get("page") || 1,
        query: queryParams.get("query") || "",
        id: queryParams.get("id") || "",
        type: SUB_ORDER_TYPE.PRODUCT
    });

    const { data, isLoading, error } = useGetSubOrders(localStorage.getItem("orgID"), query);

    const {
        handleSubmit,
        register,
        getValues,
    } = useForm({
        reValidateMode: "onChange",
        mode: "onChange",
        defaultValues: {
            id: ""
        }
    });

    useEffect(() => {
        // Используется для обновления состояние url
        urlReplaceState(null, query);
    }, [query]);

    const updateSearch = (params) => {
        setQuery({
            ...query,
            ...params,
        });
    };
    const onPageChanged = (e, _page) => {
        updateSearch({ page: _page })
    }
    const onSearch = () => {
        updateSearch({ id: getValues('id'), page: 1 })
    }

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (isLoading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }

        // Количество страниц
        const pageCount = Math.ceil(data?.count / LIMIT)
        const showPagination = pageCount > 1
        return <div>
            <AppTable data={data?.rows} columnConfig={columnConfig}></AppTable>
            <div>
                {showPagination ? <Pagination className="m-t-32" page={query.page} count={pageCount} onChange={onPageChanged} /> : null}
            </div>
        </div>

    }
    return (
        <ListPage pageTitle="История заказов" pathToAdd={`../add`}>
            <div className="m-t-32">
                <form onSubmit={handleSubmit(onSearch)} className="m-b-32 flex align-center">
                    <TextField
                        type="search"
                        label="Поиск по номеру заказа"
                        {...register('id')}
                        autoComplete="off"
                        className="m-w-100"
                        style={{ minWidth: 300 }}
                        onChange={(e) => {
                            if (e.target.value === "") {
                                updateSearch({
                                    id: '',
                                    page: 1
                                })
                            }
                        }}
                    ></TextField>
                    <Button type="submit">Поиск</Button>
                </form>
                {buildContent()}
            </div>
            {/* <pre>
                {JSON.stringify(watch())}
            </pre> */}
        </ListPage>

    );
};

export default withRouter(SubOrders);
